
import React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
// import { TooltipProvider } from '@/components/ui/tooltip';

export function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      storageKey="vite-theme"
      enableSystem
      disableTransitionOnChange
      enableColorScheme
    >
      {/* <TooltipProvider delayDuration={0}> */}
        {children}
        {/* </TooltipProvider> */}
    </NextThemesProvider>
  );
}
